import api from 'api'

export type IgnoreCompumaticPunchesParams = {
  punchIds: number[]
}

export type IgnoreCompumaticPunchesResponse = {
  updatedCount: number
}

export async function ignoreCompumaticPunches(
  params: IgnoreCompumaticPunchesParams
): Promise<IgnoreCompumaticPunchesResponse> {
  const result = await api.post<IgnoreCompumaticPunchesResponse>(
    '/admin/time_clock/compumatic_punches/ignore',
    params
  )
  return result.data
}
